export const FACILITY_REPLAY_CODES = {
  PREMISE_MISMATCH: 'facility_premise_mismatch',
  NOT_FOUND: 'facility_not_found',
  VALIDATION_FAILED: 'facility_validation_failed',
} as const;

export const REPLAY_CODE_MESSAGES: Record<string, string> = {
  [FACILITY_REPLAY_CODES.PREMISE_MISMATCH]:
    'Live facilities changed since the partner submitted this request. Ask them to open Facilities in Extranet and submit a fresh change based on the current property state.',
  [FACILITY_REPLAY_CODES.NOT_FOUND]:
    'A facility in this request no longer exists in the catalog. Ask the partner to resubmit with current facilities.',
  [FACILITY_REPLAY_CODES.VALIDATION_FAILED]:
    'This facility change could not be applied because it failed validation. Ask the partner to review their facilities in Extranet and submit a corrected change.',
};

export const DEFAULT_APPROVAL_FAILURE_MESSAGE =
  'Approval failed while applying changes to the live listing. The change remains pending.';

export const TECHNICAL_REPLAY_DETAIL_KEYS = [
  'status',
  'code',
  'message',
  'detail',
  'replayError',
  'replayStatus',
] as const;
